import React from 'react'

const NotFound = () => {
  return (
    <section className='not-found'>
      <div className='container'>
        <h3>هذا الصفحة غير متوفرة حاليا</h3>
        <a href='/'>عد إلى الصفحة الرئيسية</a>
      </div>
    </section>
  )
}

export default NotFound